import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import * as moment from 'moment';
import { Config } from 'src/app/app-constant';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { DatePipe } from '@angular/common';
import { MY_DATE_FORMATS } from 'src/app/shared/commen-function-file';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ToastrService } from 'ngx-toastr'
@Component({
  selector: 'app-add-expense-employee',
  templateUrl: './add-expense-employee.component.html',
  styleUrls: ['./add-expense-employee.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class AddExpenseEmployeeComponent implements OnInit {

  employeeForm: FormGroup;
  reimbursementTypes = ['Travel', 'Food', 'Health', 'Office Supplies']; // Example types
  uploadedFile: File | null = null;
  reimbursementTypesAndIDDD: any[] = [];
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  buttonColorName: any;
  comment: any
  fileName: any = null;
  fileType: any = null;
  allfileData: any = null;
  formData: any = new FormData();
  fileToUpload: any;
  showBrowseBtn: boolean = false;
  getUploadIncrementPolicyYear: any = []
  isDisabledUploadPolicyBtn: boolean = true;
  isFileSizeIsInvalid: boolean = false;
  letterHeadUrl: any;
  selectedFile: File | null = null;
  tableDataDetails: any;
  todayDate: any;
  dateExpense: any;
  buttonColorNamefordiable = 'blue';
  loggedInUserRole: any;
  loggedInUserRoles: any;
  arrReimbursementByBand: any[] = [];
  strUserBand: any;
    strUserGrade: any;
  strUserLocation: any;
  loggedInCompanyFiscalyear: any;
  loggedInCompanyYear: any;
  charCount: number = 0;
  charFinanceCount: number = 0;
  charManagerCount: number = 0;
  approveMatrixValue: any;
  setlimitNull: any = [];
  setlimitvaue: any
  isDetailsOpen: boolean =true;

  constructor( private toastr: ToastrService,private datePipe: DatePipe, public router: Router, private config: Config, public dialogRef: MatDialogRef<AddExpenseEmployeeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, private fb: FormBuilder, private httpService: HttpService, private loader: LoaderService, private encryptionService: EncryptionService,) {

    this.loggedInCompanyYear = this.data.year;

    // console.error( this.dateExpense)


    this.todayDate = new Date().toISOString().split('T')[0];
    let datedispay = this.datePipe.transform(this.todayDate, 'dd-MM-yyyy')
    this.employeeForm = this.fb.group({

      reimbursementType: ['', Validators.required],
      reimbursementid: [],
      dateOfApply: [{ value: datedispay, disabled: true }, Validators.required],
      claimNumber: [{ value: 'Auto-Generated', disabled: true }],
      limitOfReimbursement: [''],
      actualAmount: ['', [Validators.required, Validators.min(1)]],
      amountByFinance: [{ value: '', disabled: true }],
      status: [{ value: '', disabled: true }],
      employeeComment: [''],
      managerComment: [{ value: '', disabled: true }],
      financeComment: [{ value: '', disabled: true }],
      dateOfExpense: [{ value: '' }, Validators.required],
      file: [null],
      title: ['']
    });

    // Patch the data into the form


    if (this.data.data) {
      const rawDate = this.data?.data?.date;
      const formattedDate = rawDate ? moment(rawDate).format('MM/DD/YYYY') : null;
      this.fileName = this.data?.data?.uploadDocument;
      console.log(this.data.data);

      this.charCount = this.data?.data?.employeeComment == null ? 0 : this.data?.data?.employeeComment.length;
      this.charManagerCount = this.data?.data?.managerComment == null ? 0 : this.data?.data?.managerComment.length;
      this.charFinanceCount = this.data?.data?.financeComment == null ? 0 : this.data?.data?.financeComment.length;

      this.employeeForm.patchValue({
        reimbursementType: this.data?.data?.reimbursementid,
        reimbursementid: this.data?.data?.reimbursementid,
        // dateOfApply: this.data?.data?.date|, // Ensure it's a valid Date object
        dateOfApply: this.datePipe.transform(rawDate, 'dd-MM-yyyy'),
        dateOfExpense: this.data.data.dateOfExpense,
        limitOfReimbursement: this.data?.data?.reimbursementLimit,
        actualAmount: this.data?.data?.actualAmount,
        employeeComment: this.data?.data?.employeeComment,
        managerComment: this.data?.data?.managerComment,
        charFinanceCount: this.data?.data?.financeComment,
        status: this.data?.data?.status,
        file: this.data.uploadDocument ? this.data.uploadDocument : null,
        title: this.data.reimbursementType

      });

      this.dateExpense = this.data?.data?.dateOfExpense;
    }

  }
  /*   preventNegative(event: KeyboardEvent): void {
      // Allow numbers (0-9), Backspace, Delete, Tab, Arrow keys, and Enter
      const allowedKeys = [
        'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter',
      ];
      const isNumber = event.key >= '0' && event.key <= '9';
  
      if (!isNumber && !allowedKeys.includes(event.key)) {
        event.preventDefault();
      }
    }
    
    sanitizeInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      // Replace any non-numeric value in the input
      input.value = input.value.replace(/[^0-9]/g, '');
    } */
  preventNegative(event: KeyboardEvent): void {

    // Allow numbers (0-9), Backspace, Delete, Tab, Arrow keys, Enter, and a single decimal point
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter', '.'
    ];

    const isNumber = event.key >= '0' && event.key <= '9';
    const isDecimalPoint = event.key === '.';
    console.error(isDecimalPoint);

    // Check if the input already contains a decimal point
    const input = (event.target as HTMLInputElement);
    const hasDecimal = input.value.includes('.');

    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }

    // Prevent entering a second decimal point
    if (isDecimalPoint && hasDecimal) {
      event.preventDefault();
    }
  }

  sanitizeInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Replace any non-numeric value except a single decimal point
    input.value = input.value.replace(/[^0-9.]/g, '');

    // Ensure there is only one decimal point
    const parts = input.value.split('.');
    if (parts.length > 2) {
      input.value = parts[0] + '.' + parts.slice(1).join('');
    }

    // Automatically prepend a '0' if the value starts with a decimal point
    if (input.value.startsWith('.') && input.value.length > 1) {
      input.value = '0' + input.value;
    }

    // Prevent the value from being just a single '.'
    if (input.value === '.') {
      input.value = '';
    }
  }

  updateCharCount(value: any): void {
    this.charCount = value.target.value.length;
    const textarea = value.target as HTMLTextAreaElement;
    textarea.style.height = 'auto'; // Reset height to calculate the new height correctly
    textarea.style.height = `${textarea.scrollHeight}px`; // Set height based on content
    console.error(textarea.scrollHeight)

  }
  updateCharManagerCount(value: any): void {
    this.charManagerCount = value.target.value.length;
  }
  updateCharFinanceCount(value: any): void {
    this.charFinanceCount = value.target.value.length;
  }


  ngOnInit(): void {


    this.buttonColorName = sessionStorage.getItem('buttonColorName');

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');


    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }



    // this.getallReimbursements();
    setTimeout(() => {
      if (this.data) {
        this.onReimbursementTypeChange(this.data?.data?.reimbursementid)
      }
    }, 500)


    this.httpService.callGetService(`${this.config.getBandByUserId}/${this.loggedInUserId}`)
      .subscribe(
        (response: any) => {
          console.log(
            response
          );

          if (response.data) {
            this.strUserBand = response.data.band;
            this.strUserGrade=response?.data?.grade;
            this.strUserLocation = response.data.location;
            this.getallReimbursements();
          }


        },
        (error: any) => {
        }
      );



  }
  disablePastDates = (date: Date | null): boolean => {
    if (!date) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset to start of the day
    return date >= today;
  };

  hasError(controlName: string, errorType: string) {
    const control = this.employeeForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }


  onFileSelected(event: Event) {
    const inputEvent: any = event.target as HTMLInputElement;
    this.fileName = null;
    this.fileType = null;
    this.formData = new FormData();
    const fileSizeInKB = inputEvent.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;
    if (!inputEvent.files[0] || inputEvent.files[0].length == 0) {
      return;
    }
    if (inputEvent.files[0].name.includes('csv') && !inputEvent.files[0].name.includes('CSV') && !inputEvent.files[0].name.includes('xlsx') && !inputEvent.files[0].name.includes('XLSX')) {
      window.alert("File format is not supported");
      return;
    }
    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }
    if (inputEvent.files[0]) {
      this.fileName = inputEvent.files[0].name;
      this.fileType = inputEvent.files[0].type;
      this.allfileData = inputEvent.files[0];
      this.formData = new FormData();
      this.formData.append('file', inputEvent.files[0]);

      this.formData.append('companyId', this.loggedInUserCompanyID);
      this.showBrowseBtn = true;
      this.isDisabledUploadPolicyBtn = false;
      this.isFileSizeIsInvalid = false;
      // const url = this.config.uploadFile + `?fileName=${this.fileName}&fileType=${this.fileType}`;
      // this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
      //   this.letterHeadUrl=data?.data;
      // })
    }
  }


  onFile(event: any) {
    const file = event.target.files[0];

    if (file) {
      this.selectedFile = file;
      this.employeeForm.patchValue({ file });

    }
  }

  deleteFile(): void {
    this.uploadedFile = null;
  }


  getallReimbursements() {
    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.loggedInCompanyYear}`)
    // this.httpService.callGetService(`${this.config.viewAllReimbursements}/${this.selectedYearForCompetency}`)
    .subscribe({
      next: (result: any) => {

        let arrAllReimbursement = result.data.filter((elm: any) => elm.setLimit === true);
        let arrAllReimbursementForFalse = result.data.filter((elm: any) => elm.setLimit === false);
        this.setlimitvaue = arrAllReimbursement[0]?.setLimit;
      }
    })
      
    this.httpService.callGetService(`${this.config.getAllReibursementDetails}/${this.loggedInUserCompanyID}`)
      .subscribe({
        next: (result: any) => {

          var arrReimbursement = result.data;
          console.log(arrReimbursement);
          
          this.setlimitNull = result.data.map((elm: any) => elm.setLimit);

              console.log(this.setlimitNull);

          this.approveMatrixValue = arrReimbursement[0]?.approvedMatrix;
         
          arrReimbursement.forEach((elm: any, i: any) => {
            console.log(this.strUserBand);
            console.log(this.strUserGrade);
            
            console.log(elm);
           if ((elm.band != null) && (elm.band === this.strUserBand)&&(elm.limitType==='Band')) {
              this.employeeForm.get('limitOfReimbursement')?.setValidators(Validators.required);
              this.employeeForm.get('limitOfReimbursement')?.updateValueAndValidity();
              this.arrReimbursementByBand.push(elm);
              this.reimbursementTypesAndIDDD = this.arrReimbursementByBand;
            }
            else if ((elm.band != null) && (elm.band === this.strUserBand)&&(elm.grade===this.strUserGrade)) {
              this.employeeForm.get('limitOfReimbursement')?.setValidators(Validators.required);
              this.employeeForm.get('limitOfReimbursement')?.updateValueAndValidity();
              this.arrReimbursementByBand.push(elm);
              this.reimbursementTypesAndIDDD = this.arrReimbursementByBand;
            } else if ((elm.location != null) && (elm.location == this.strUserLocation)) {
              this.employeeForm.get('limitOfReimbursement')?.setValidators(Validators.required);
              this.employeeForm.get('limitOfReimbursement')?.updateValueAndValidity();
              this.arrReimbursementByBand.push(elm);

              this.reimbursementTypesAndIDDD = this.arrReimbursementByBand;
            } else if (
              (!this.setlimitNull.includes(true)) &&
              elm.financeAccessEmployeeIds.length > 0
            ) {
              this.employeeForm.get('limitOfReimbursement')?.clearValidators();
              this.employeeForm.get('limitOfReimbursement')?.updateValueAndValidity();
              this.arrReimbursementByBand.push(elm);
              this.reimbursementTypesAndIDDD = this.arrReimbursementByBand;

            } else {
              //Neither Condition
              if (elm.limitType == 'Neither') {
                this.employeeForm.get('limitOfReimbursement')?.setValidators(Validators.required);
                this.employeeForm.get('limitOfReimbursement')?.updateValueAndValidity();
                this.arrReimbursementByBand.push(elm);
                this.reimbursementTypesAndIDDD = this.arrReimbursementByBand;

              }

            }
          })

        }

      })


  }

  //add new comment
  getAllEmployeeListing() {
    this.httpService.callGetService(`${this.config.allReimbursementApplication}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {
        this.tableDataDetails = result;

        this.tableDataDetails.forEach((elm: any, i: any) => {
          if (elm.uploadDocument) {
            this.tableDataDetails[i].uploadDocument = this.config.uploads + elm.uploadDocument;
          }
        })


      });
  }
  PatchData: any;
  onReimbursementTypeChange(event: any) {
    // The selected value will be available in event.value
    this.PatchData = this.reimbursementTypesAndIDDD.filter((elm: any) => elm.reimbursementId == event)


    this.employeeForm.patchValue({
      limitOfReimbursement: this.PatchData[0]?.amountLimit, // Set the amount limit here
      reimbursementid: this.PatchData[0]?.reimbursementid,
      status: this.PatchData[0]?.status
    });

  }

  onRemovemisAttachment() {
    this.fileName = null;
  }

  downloadMisFile(fileName: any) {
    saveAs(fileName);
  }
  // saveEmployeeData() {
  //   // uplode api Call
  //   const url = this.config.uploadFile + `?fileName=${this.fileName}&fileType=${this.fileType}`;

  //   this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
  //     this.letterHeadUrl = data?.data;
  //   })
  //   const dateOfApply = this.employeeForm.get('dateOfApply')?.value; // 'DD-MM-YYYY'
  //   const formattedDate = moment(dateOfApply, 'DD-MM-YYYY').format('YYYY-MM-DD');
  //   const date = new Date(this.employeeForm.value.dateOfExpense);
  //   const formattedDateOfExpense = date.getFullYear() + '-' +
  //     String(date.getMonth() + 1).padStart(2, '0') + '-' +
  //     String(date.getDate()).padStart(2, '0');

  //   let formData = {

  //     "companyId": this.loggedInUserCompanyID,
  //     "managerId": null,
  //     "financeId": null,
  //     "reimbursementid": this.employeeForm.value.reimbursementType,
  //     "reimbursementType": this.employeeForm.value.reimbursementType ? this.PatchData[0]?.reimbursementType : '',
  //     "date": formattedDate,
  //     "reimbursementLimit": this.employeeForm.value.limitOfReimbursement,
  //     "actualAmount": this.employeeForm.value.actualAmount,
  //     "assignedAmount": null,
  //     "employeeComment": this.employeeForm.value.employeeComment,
  //     "managerComment": null,
  //     "financeComment": null,
  //     "uploadDocument": this.fileName,
  //     "dateOfExpense": formattedDateOfExpense,
  //     "employeeId": parseInt(this.loggedInUserId),
  //     "year": this.loggedInCompanyYear,
  //     "fiscal_year": this.loggedInCompanyFiscalyear
  //   }


  //   if (this.PatchData[0].approvedMatrix == 'EMPLOYEE_TO_FINANCE') {


  //     //save api call
  //     this.httpService.callPostService(`${this.config.allReimbursementApplicationForEmployeeToFinance}`, formData)
  //       .subscribe({
  //         next: (result: any) => {

  //           if (result) {
  //             this.toastr.success(result.message,'success');
  //             this.closeDialog();

  //           }

  //         }

  //       })
  //   } else {
  //     this.httpService.callPostService(`${this.config.reimbursementsApplications}`, formData)
  //       .subscribe({
  //         next: (result: any) => {

  //           if (result) {
  //             this.toastr.success(result.message,'success');
  //             this.closeDialog();

  //           }

  //         }

  //       })
  //   }

  // }

  
  isSaving: boolean = false; 
  saveEmployeeData() {
     if (this.isSaving) return;
     this.isSaving = true;
    // uplode api Call
    const url = this.config.uploadFile + `?fileName=${this.fileName}&fileType=${this.fileType}`;

    this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
      this.letterHeadUrl = data?.data;
    })
    const dateOfApply = this.employeeForm.get('dateOfApply')?.value; // 'DD-MM-YYYY'
    const formattedDate = moment(dateOfApply, 'DD-MM-YYYY').format('YYYY-MM-DD');
    const date = new Date(this.employeeForm.value.dateOfExpense);
    const formattedDateOfExpense = date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');

    let formData = {

      "companyId": this.loggedInUserCompanyID,
      "managerId": null,
      "financeId": null,
      "hrAdminId": null,
      "reimbursementid": this.employeeForm.value.reimbursementType,
      "reimbursementType": this.employeeForm.value.reimbursementType ? this.PatchData[0]?.reimbursementType : '',
      "date": formattedDate,
      "reimbursementLimit": this.employeeForm.value.limitOfReimbursement,
      "actualAmount": this.employeeForm.value.actualAmount,
      "assignedAmount": null,
      "employeeComment": this.employeeForm.value.employeeComment,
      "managerComment": null,
      "financeComment": null,
      "uploadDocument": this.fileName,
      "dateOfExpense": formattedDateOfExpense,
      "employeeId": parseInt(this.loggedInUserId),
      "year": this.loggedInCompanyYear,
      "fiscal_year": this.loggedInCompanyFiscalyear
    }



    const handleSuccess = (result: any) => {
      if (result) {
        this.toastr.success(result.message, 'Success');
        this.closeDialog();
        this.isSaving = false;
      }
    };
  
    const handleError = (error: any) => {
      this.isSaving = false;
      if (error?.status === 409) {
        this.toastr.error(error?.error?.message || 'Duplicate entry found', 'Error');
      } else {
        this.toastr.error('Something went wrong. Please try again later.', 'Error');
      }
    };

    if (this.PatchData[0].approvedMatrix === 'EMPLOYEE_TO_FINANCE') {
      this.httpService.callPostService(this.config.allReimbursementApplicationForEmployeeToFinance, formData)
        .subscribe({
          next: handleSuccess,
          error: handleError
        });
    }else {
      this.httpService.callPostService(this.config.reimbursementsApplications, formData)
        .subscribe({
          next: handleSuccess,
          error: handleError
        });
    }

  }


  updateData() {
  

    const file: File = this.formData.get('file'); // assuming 'file' is the key
    const fileTypes = file?.type;
 
    const fileType = this.fileName.split(".").pop(); 

    const dateOfApply = this.employeeForm.get('dateOfApply')?.value;
                  
    const parts = dateOfApply.split("-");
    const [day, month, year] = parts;
      
    const formattedDate = year+'-'+month+'-'+day;
    // console.log(formattedDate)
    // return false;
    //  Upload file
    const strFileType = (this.fileType) ? this.fileType : fileType;
        
    if(fileTypes != undefined){
       const url = this.config.uploadFile + `?file=${this.fileName}`;
      this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
        this.letterHeadUrl = data?.data;
      });
    }
   

    const date = new Date(this.employeeForm.value.dateOfExpense);
    const formattedDateOfExpense = date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
    let formData = {

      "companyId": this.loggedInUserCompanyID,
      "managerId": null,
      "financeId": null,
      "hrAdminId": null,
      "reimbursementid": this.employeeForm.value.reimbursementType,
      "reimbursementType": this.employeeForm.value.reimbursementType ? this.PatchData[0]?.reimbursementType : '',
      "date": formattedDate,
      "reimbursementLimit": this.employeeForm.value.limitOfReimbursement,
      "actualAmount": this.employeeForm.value.actualAmount,
      "assignedAmount": null,
      "employeeComment": this.employeeForm.value.employeeComment,
      "managerComment": null,
      "financeComment": null,
      "uploadDocument": this.fileName,
      "employeeId": parseInt(this.loggedInUserId),
      "dateOfExpense": formattedDateOfExpense,
    }

    this.httpService.callPutService(`${this.config.reimbursementsUpdate}/${this.data.data.reimbursementApplicationId}`, formData)
      .subscribe({
        next: (result: any) => {

          if (result) {
            this.toastr.success(result.message,'success');
            this.closeDialog();
            this.isDetailsOpen =false;
          }

        }

      })
  }

  closeDialog() {
    this.dialogRef.close();

  }
}
